import { render, staticRenderFns } from "./notificacionesEdit.vue?vue&type=template&id=4fab060e&"
import script from "./notificacionesEdit.vue?vue&type=script&lang=js&"
export * from "./notificacionesEdit.vue?vue&type=script&lang=js&"
import style0 from "./notificacionesEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports